import { render } from "./DashboardContainer.vue?vue&type=template&id=c0405050&scoped=true"
import script from "./DashboardContainer.vue?vue&type=script&lang=js"
export * from "./DashboardContainer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c0405050"
/* hot reload */
if (module.hot) {
  script.__hmrId = "c0405050"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0405050', script)) {
    api.reload('c0405050', script)
  }
  
  module.hot.accept("./DashboardContainer.vue?vue&type=template&id=c0405050&scoped=true", () => {
    api.rerender('c0405050', render)
  })

}

script.__file = "src/components/dashboard/DashboardContainer.vue"

export default script